import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Row, Col, Button, Card, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import TableSearch from "../../../../Components/TableSearch";

import { useHistory } from "react-router-dom";
import { getFilterMetaData } from "../../../../actionCreators/Property";
import { transformFilterMetaData } from "../../../../utils";
import { getAllDistrictAdmin } from "../../../../actionCreators/DistrictAdmin";

const baseURL = process.env.REACT_APP_API_URL;

function ListDistrictAdmin({ getAllDistrictAdmin, districtAdminList, getFilterMetaData, filterMetaData }) {
  const styles = {
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    contentWrapper: {
      marginLeft: "10px",
      marginRight: "10px",
    },
  };

  const history = useHistory();

  const displayTotalETO = (value) =>
    [undefined, null].includes(value) ? "" : ` (${value})`;
  const [isDownloading, setIsDownloading] = React.useState(false);

  React.useEffect(() => {
    getAllDistrictAdmin({
      page: 1,
      pageSize: 10,
      searchString: "",
      filterBody: JSON.stringify({
        zone: [],
        district: [],
        status: null,
      }),
    });
    getFilterMetaData();
  }, []);

  return (
    <React.Fragment>
      <div style={styles.titleButtonParent}>
        <div>
          <Typography className="heading">{`District Admin${displayTotalETO(
            districtAdminList?.data?.totalRecords
          )}`}</Typography>
        </div>
        <div style={styles.buttonWrapper}>
          <Button
            style={styles.uploadButton}
            type="primary"
            icon={<PlusOutlined />}
            size={"large"}
            onClick={() => history.push("/admin/add-district-admin")}
          >
            Add District Admin
          </Button>
        </div>
      </div>

      {[undefined, null].includes(filterMetaData?.data) ? (
        <div className="spin-loader">
          <Spin size="large" />
        </div>
      ) : (
        <Card bordered={false}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <TableSearch
                onRowClick={(x) => history.push(`/admin/edit-district-admin?id=${x?.id}`)}
                tableName={"district_admins"}
                data={districtAdminList?.data}
                sendRequestParams={(x) =>{
                  getAllDistrictAdmin({
                    page: x?.page,
                    pageSize: x?.size,
                    searchString: x?.searchText,
                    filterBody: JSON.stringify(x?.filterBody),
                  })}
                }
                filterMetaData={transformFilterMetaData(filterMetaData?.data)}
                loading={districtAdminList?.loading}
              />
            </Col>
          </Row>
        </Card>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = ({
  user: user,
  districtAdmin: { districtAdminList },
  property: { filterMetaData },
}) => ({
  user,
  districtAdminList,
  filterMetaData
});

const mapDispatchToProps = (dispatch) => ({
  getAllDistrictAdmin: bindActionCreators(getAllDistrictAdmin, dispatch),
  getFilterMetaData: bindActionCreators(getFilterMetaData, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ListDistrictAdmin);
